var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            {
              directives: [
                {
                  name: "infinite-scroll",
                  rawName: "v-infinite-scroll",
                  value: _vm.load,
                  expression: "load"
                }
              ],
              staticClass: "main",
              attrs: {
                "infinite-scroll-delay": "200",
                "infinite-scroll-distance": "200"
              }
            },
            [
              _c("SubTitleComponent", { attrs: { title: _vm.title } }),
              _vm._v(" "),
              _c("div", { staticClass: "box" }, [
                _c(
                  "div",
                  { staticClass: "filter" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c("el-col", { attrs: { span: 3 } }, [
                          _c("h4", [_vm._v("我的客户")])
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 6 } }, [
                          _c(
                            "div",
                            { staticClass: "grid-content" },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入内容",
                                  "prefix-icon": "el-icon-search"
                                },
                                on: { change: _vm.onChange },
                                model: {
                                  value: _vm.searchInput,
                                  callback: function($$v) {
                                    _vm.searchInput = $$v
                                  },
                                  expression: "searchInput"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 4, offset: 6 } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  icon: "el-icon-circle-plus-outline",
                                  type: "success"
                                },
                                on: { click: _vm.toNew }
                              },
                              [
                                _c("span", { staticClass: "btn" }, [
                                  _vm._v("创建新客户")
                                ])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  icon: "el-icon-right",
                                  type: "success"
                                },
                                on: { click: _vm.toHistory }
                              },
                              [
                                _c("span", { staticClass: "btn" }, [
                                  _vm._v("查看历史客户")
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.customerData.length > 0
                  ? _c(
                      "ul",
                      {
                        staticClass: "list",
                        staticStyle: { overflow: "auto" }
                      },
                      _vm._l(_vm.customerData, function(item) {
                        return _c(
                          "li",
                          {
                            key: "customer" + item.client_id,
                            staticClass: "item"
                          },
                          [
                            _c("div", { staticClass: "id" }, [
                              _vm._v(_vm._s(item.number))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "name" }, [
                              _vm._v(_vm._s(item.client_name))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info" }, [
                              _c("span", [_vm._v(_vm._s(item.city_name))]),
                              _c("span", [_vm._v(_vm._s(item.industry_type))]),
                              _c("span", [_vm._v(_vm._s(item.project_type))]),
                              _c("span", [
                                _vm._v(_vm._s(item.project_area) + "m²")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "date" }, [
                              _vm._v(_vm._s(item.date))
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "detail",
                                attrs: { size: "mini", type: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.toDetail(item.client_id)
                                  }
                                }
                              },
                              [_vm._v("查看详情")]
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.customerData.length <= 0
                  ? _c(
                      "div",
                      { staticClass: "list" },
                      [_c("el-empty", { attrs: { description: "暂无数据" } })],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23543608", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23543608","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Index.vue
// module id = null
// module chunks = 